/*
 * Sticky add-to-cart bar (FiruBack).
 *
 * - Appears once the main add-to-cart button has scrolled out of view, hides while
 *   the cart drawer is open.
 * - On click: if the pack, variants and required personalization are complete, it
 *   delegates to the real add-to-cart button with dispatchEvent(new Event('click'))
 *   (client requirement) so product-form.js adds the exact selection and opens the
 *   cart drawer. Otherwise it scrolls back to the personalization area and focuses
 *   what is missing.
 * - Validation and the in-flight lock live in assets/product-personalization.js
 *   (window.FiruProductSelection).
 */
(function () {
  'use strict';

  function initBar(bar) {
    if (!bar || bar.dataset.initialized === 'true') return;
    bar.dataset.initialized = 'true';

    var sectionId = bar.dataset.sectionId;
    var button = bar.querySelector('[data-sticky-atc-button]');
    var label = bar.querySelector('[data-sticky-atc-label]');
    var priceEl = bar.querySelector('[data-sticky-atc-price]');
    var spinner = button ? button.querySelector('.loading__spinner') : null;
    var loadingTimer = null;
    var defaultLabel = bar.dataset.label || (label ? label.textContent.trim() : '');
    var incompleteLabel = bar.dataset.incompleteLabel || defaultLabel;
    var labelTimer = null;

    var mainButtonVisible = false;
var drawerOpen = false;

    function selection() {
      return window.FiruProductSelection || null;
    }

    function getForm() {
      return document.getElementById(bar.dataset.formId) || document.querySelector('form[data-type="add-to-cart-form"]');
    }

    function getMainButton() {
      return document.getElementById(bar.dataset.submitId)
        || (getForm() && getForm().querySelector('.product-form__submit'))
        || document.querySelector('.product-form__submit');
    }

    function getSentinel() {
      var form = getForm();
      return (form && form.querySelector('.product-form__buttons')) || document.querySelector('.product-form__buttons');
    }

    /* ---------- visibility ---------- */

    function render() {
  var visible = !mainButtonVisible && !drawerOpen;

  bar.classList.toggle('sticky-atc--visible', visible);
  bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
  document.documentElement.classList.toggle('sticky-atc-active', visible);
}

function watchMainButton() {
  var mainButton = getMainButton();

  if (!mainButton) {
    mainButtonVisible = false;
    render();
    return;
  }

  function checkVisibility() {
    var rect = mainButton.getBoundingClientRect();

    mainButtonVisible =
      rect.top < window.innerHeight &&
      rect.bottom > 0;

    render();
  }

  checkVisibility();

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        mainButtonVisible = entry.isIntersecting;
      });

      render();
    }, {
      threshold: 0.01
    });

    observer.observe(mainButton);
  }

  var ticking = false;

  function requestCheck() {
    if (ticking) return;

    ticking = true;

    window.requestAnimationFrame(function () {
      ticking = false;
      checkVisibility();
    });
  }

  window.addEventListener('scroll', requestCheck, { passive: true });
  window.addEventListener('resize', requestCheck);
}

    function watchDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || !('MutationObserver' in window)) return;
      var update = function () {
        drawerOpen = drawer.classList.contains('active');
        render();
      };
      new MutationObserver(update).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      update();
    }

    function watchHeight() {
      var setHeight = function () {
        document.documentElement.style.setProperty('--sticky-atc-height', bar.offsetHeight + 'px');
      };
      if ('ResizeObserver' in window) {
        new ResizeObserver(setHeight).observe(bar);
      } else {
        window.addEventListener('resize', setHeight);
      }
      setHeight();
    }

    /* ---------- price / state mirroring ---------- */

    function readThemePrice() {
      var container = document.querySelector('#price-' + sectionId + ' .price');
      if (!container) return '';
      var el = container.classList.contains('price--on-sale')
        ? container.querySelector('.price__sale .price-item--sale')
        : container.querySelector('.price__regular .price-item--regular');
      return el ? el.textContent.trim() : '';
    }

    function updatePrice() {
      if (!priceEl) return;
      var text = readThemePrice();
      if (text) priceEl.textContent = text;
    }

    function syncWithMainButton() {
      var main = getMainButton();
      if (!main || !button) return;
      button.disabled = !!main.disabled;
      if (main.disabled) {
        var span = main.querySelector('span');
        if (span && label) label.textContent = span.textContent.trim();
      } else if (label && !labelTimer) {
        label.textContent = defaultLabel;
      }
    }

    /* ---------- loading state (mirrors product-form.js on the main button) ---------- */

    function setLoading(on) {
      if (!button) return;
      button.classList.toggle('loading', !!on);
      button.setAttribute('aria-disabled', on ? 'true' : 'false');
      if (spinner) spinner.classList.toggle('hidden', !on);
      if (loadingTimer) window.clearTimeout(loadingTimer);
      loadingTimer = null;
      if (on) {
        // Safety net: never leave the spinner stuck (the selection lock lasts 5 s).
        loadingTimer = window.setTimeout(function () { setLoading(false); }, 6000);
      }
    }

    document.addEventListener('firu:selection:lock', function () { setLoading(true); });
    document.addEventListener('firu:selection:unlock', function () { setLoading(false); });

    function flashIncompleteLabel() {
      if (!label) return;
      label.textContent = incompleteLabel;
      if (labelTimer) window.clearTimeout(labelTimer);
      labelTimer = window.setTimeout(function () {
        labelTimer = null;
        label.textContent = defaultLabel;
      }, 2500);
    }

    var priceTimer = null;
    function schedulePriceUpdate() {
      if (priceTimer) window.clearTimeout(priceTimer);
      priceTimer = window.setTimeout(function () {
        priceTimer = null;
        updatePrice();
        syncWithMainButton();
      }, 120);
    }

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, schedulePriceUpdate);
    }

    /* ---------- click ---------- */

    function scrollToSelectionArea(sel) {
      var problem = sel ? sel.firstProblem() : null;
      if (sel && problem) {
        sel.focusProblem(problem);
        return;
      }
      var target = document.getElementById('ProductPersonalization-' + sectionId)
        || getSentinel();
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    if (button) {
      button.addEventListener('click', function () {
        var main = getMainButton();
        if (!main) {
          scrollToSelectionArea(selection());
          return;
        }
        if (main.disabled || button.disabled) return;

        var sel = selection();
        if (sel && sel.isInFlight()) return;
        if (button.classList.contains('loading')) return;

        if (sel && !sel.isComplete()) {
          flashIncompleteLabel();
          scrollToSelectionArea(sel);
          return;
        }

        // Keep keyboard focus on the real control so focus returns somewhere visible
        // when the cart drawer closes.
        try { main.focus({ preventScroll: true }); } catch (e) { /* ignore */ }

        if (sel) sel.markStickyDispatch();
        // Client requirement: trigger the real add-to-cart element.
        var clickEvent = new Event('click', { bubbles: true, cancelable: true });
        var notPrevented = main.dispatchEvent(clickEvent);

        // A real click on a submit button ends with the browser submitting the form;
        // a synthetic Event('click') has no such default action. So when nobody
        // prevented the event (our validation gate), submit the form exactly like
        // the browser would have done.
        if (notPrevented) {
          var form = getForm();
          if (form) {
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit(main);
            } else {
              form.submit();
            }
          }
        }
      });
    }

    watchMainButton();
    watchDrawer();
    watchHeight();
    updatePrice();
    syncWithMainButton();
  }

  function initAll() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();